watchFragmentOptions